import AppConstants from '../../../../../config/app.constants';
import ContractBaseController from '../common/contract.base.controller'
// import ServiceOptionController from '../../customer/common/service_options/service_option.controller';

class ContractCreateController extends ContractBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, ContractService, Modal, $translate, $scope, $timeout, $filter, BillableEventsService,
				CommonLayoutService, LocationDistanceService,DateUtil, ContractTypeService) {

		super(Auth, $state, User, ContractService, Modal, $translate, $scope, $timeout)

		this.$scope = $scope;
		this.DateUtil = DateUtil;
		this.defaultModel = {
			contractId: '',
			contractName: '',
			status: true,
			selectedBillingDuration: '',
			description: '',
			contractStartDate: null,
			contractEndDate: null,
			useCustomerOnBillingRules: false,
			bailmentInterest: null,
			contractTypeId:'',
			locationList: [],
			customerObj: {
				loading: false,
				totalRecords: 0,
				results: [],
				pagination: {
					page: 1,
					total: 0,
					pageLimit: 10,
					maxPages: 10
				},
			},
			contractTypeObj: {
				loading: false,
				totalRecords: 0,
				results: [],
				pagination: {
					page: 1,
					total: 0,
					pageLimit: 10,
					maxPages: 10
				},
			},
		}

		this.model = angular.copy(this.defaultModel);
		this.billingIncrementList = [
			{ label: this.$translate.instant('contract.daily'), value: 'DAILY' },
			{ label: this.$translate.instant('contract.weekly'), value: 'WEEKLY' },
			{ label: this.$translate.instant('contract.bi_weekly'), value: 'BI_WEEKLY' },
			{ label: this.$translate.instant('contract.monthly'), value: 'MONTHLY' },
			{ label: this.$translate.instant('contract.quarterly'), value: 'QUARTERLY' },
			{ label: this.$translate.instant('contract.annually'), value: 'ANNUALLY' }
		];

		this.branchId = this.User.getUser().branchId;
		this.contractRules = [];
		this.billingRulesOptions = [];
		this.showAllFlag = false;
		this.$filter = $filter;
		this.BillableEventsService = BillableEventsService;
		this.CommonLayoutService = CommonLayoutService;
		this.LocationDistanceService = LocationDistanceService;
		this.ContractTypeService = ContractTypeService;
		this.loggedInUserId = this.User.getUser().id;
		// this.billingEventOptions = [
		// 	{
		// 		label: 'Shipment Delivery',
		// 		value: 'shipment-delivered'
		// 	},
		// 	{
		// 		label: 'Shipment Pickup',
		// 		value: 'shipment-pickup'
		// 	},
		// 	{
		// 		label: 'ATM Load Service',
		// 		value: 'atm-load-service'
		// 	},
		// 	{
		// 		label: 'ATM Residual Count',
		// 		value: 'atm-residual-count'
		// 	},
		// 	{
		// 		label: 'ATM Order Pack',
		// 		value: 'atm-order-pack'
		// 	},
		// 	{
		// 		label: 'ATM Residual Deposit',
		// 		value: 'atm-residual-deposit'
		// 	},
		// 	{
		// 		label: 'Delivery Order Pack',
		// 		value: 'delivery-order-pack'
		// 	},
		// 	{
		// 		label: 'Pickup Deposit',
		// 		value: 'pickup-deposit'
		// 	},
		// 	{
		// 		label: 'Service Ticket Completed',
		// 		value: 'service-ticket-completed'
		// 	},
		// 	{
		// 		label: 'Part Charge',
		// 		value: 'part-charge'
		// 	}
		// ];

		this.locationTypeOptions = {
			'ATM': [{
				label: 'ATM',
				value: 'atm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
			{
				label: 'Regular',
				value: 'regular'
			},
			{
				label: 'NSNG',
				value: 'nsng'
			},
			{
				label: 'On Call',
				value: 'on_call'
			},
			{
				label: 'Bank',
				value: 'bank'
			}]
		};

		this.serviceTypeOptions = {
			'regular': [{
				label: 'Scheduled',
				value: 'regular'
			}],
			'flm': [{
				label: 'FLM',
				value: 'flm'
			}],
			'slm': [{
				label: 'SLM',
				value: 'slm'
			}],
			'other': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
			{
				label: 'Scheduled',
				value: 'regular'
			}
			],
			'atmLoad': [{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
			{
				label: 'Scheduled',
				value: 'regular'
			},
			{
				label: 'Emergency',
				value: 'emergency'
			}],
			'none': [{
				label: 'none',
				value: 'none'
			}],
		};

		this.scheduleTypeOptions = [
			{
				label: 'Any',
				value: 'any'
			},
			{
				label: 'Scheduled',
				value: 'scheduled'
			},
			{
				label: 'Unscheduled',
				value: 'unscheduled'
			},
		];

		this.orderTypeOptions = {
			'cash_coin': [{
				label: 'Cash & Coin',
				value: 'cash_and_coin'
			}],
			'cash_only': [{
				label: 'Cash',
				value: 'cash'
			}],
			'coin_only': [{
				label: 'Coin',
				value: 'coin'
			}],
			'ATM': [{
				label: 'ATM-Any',
				value: 'atm_any'
			},
			{
				label: 'ATM-Add',
				value: 'atm_add'
			},
			{
				label: 'ATM-Swap',
				value: 'atm_swap'
			},
			{
				label: 'ATM-ICL',
				value: 'atm_icl'
			},
			{
				label: 'ATM-CCL',
				value: 'atm_ccl'
			},
			{
				label: 'ATM-Recash',
				value: 'atm_recash'
			},
			{
				label: 'ATM-Decash',
				value: 'atm_decash'
			}],
			'services': [{
				label: 'Service Order',
				value: 'service_order'
			}],
			'other': [{
				label: 'none',
				value: 'none'
			}],
		};

		this.billingTypeOptions = this.CommonLayoutService.billingTypeOptions();
		this.serviceTimeOptions = this.CommonLayoutService.serviceTimeTypes();
		this.serviceTimeTypes = this.CommonLayoutService.serviceTimeTypes();
		this.disableOtherOptions = {};
		this.disableScheduleTypeOptions = {};
		this.showBillingWarning = false;
		this.stats = {
			pre: 'PRE',
			post: 'POST'
		}

		this.allowScheduleTypeBillingEvents = ['atm-deposit-count', 'delivery-order-pack', 'service-ticket-cancelled', 'service-ticket-incomplete',
			'atm-residual-deposit', 'atm-order-pack', 'atm-residual-count', 'part-charge', 'service-ticket-completed', 'residual-deposit', 'pickup-deposit',
			'order-packing-pack', 'atm-service'];
		this.requiredStartDate = false;
		this.requiredStartDateErrorMsg = 'As this contract does not have a start date, it will not generate pre/post bill records if any pre/post bill rules are defined.';

		this.contractLocationListObj = {
			pagination: {
				page: 1,
				total: 0,
				pageLimit: 200,
				maxPages: 10
			},
		}

		this.contractRulesStatus = {
			active: true,
			suspended: false
		}

		this.staticBillingEvents = ['pre-bill', 'post-bill'];
	}

	$onInit() {
		this.getBillableEvents();
		this.locationDistanceList();
		this.getContractLocationList();
		this.getCustomerList();
		this.getContractTypeList('',0);
		this.startDateErrorMessage = this.requiredStartDateErrorMsg;
		this.startMaxDate = {
			minDate: new Date()
		}
		this.ruleStartDateOptions ={
			minDate: moment(this.model.contractStartDate || new Date()),
			...(this.model.contractEndDate && { maxDate: moment(this.model.contractEndDate) })
		} 
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.contractRules = [];
		this.billingRulesOptions = [];
		this.requiredStartDate = false;
		this.clearErrors();
		this.model.locationList = this.cloneContractLocationListLObj.locationList
		this.model.totalLocations = this.cloneContractLocationListLObj.totalLocations;
		this.model.customerObj.totalRecords = this.cloneCustomerListLObj.totalCustomers;
		this.model.customerObj.results = this.cloneCustomerListLObj.customerList
		this.model.contractTypeId = this.model.contractType;
		this.getContractTypeList('',0);
		this.locationDistanceList();
		this.contractDatesChanged();
	}

	isBailmentInterestValid() {
		const bailmentInterestRegex = /^(?:100(?:\.0{1,2})?|([1-9][0-9]?|0)(?:\.[0-9]{1,2})?)%?$/;
		return this.model.bailmentInterest === null || this.model.bailmentInterest === '' || bailmentInterestRegex.test(this.model.bailmentInterest);
	}

	submit(evt) {
		setTimeout(() => {
			this.generateBillingRules('value');
			this.Service.create({
				id: this.model.contractId,
				contractName: this.model.contractName,
				status: this.model.status,
				billingIncrement: this.model.selectedBillingDuration,
				description: this.model.description,
				contractRules: this.contractRules,
				contractStartDate: this.model.contractStartDate ? moment(this.model.contractStartDate).format('YYYY-MM-DD') : null,
				contractEndDate: this.model.contractEndDate ? moment(this.model.contractEndDate).format('YYYY-MM-DD') : null,
				useCustomerOnBillingRules: this.model.useCustomerOnBillingRules,
				createdByUserId: this.loggedInUserId,
				modifiedByUserId: this.loggedInUserId,
				bailmentInterest: this.model.bailmentInterest ? this.convertStr(this.model.bailmentInterest) : null,
				contractTypeId: this.model.contractTypeId ? this.model.contractTypeId.Value : null
			}, this.branchId)
				.then((data) => {
					this.askCreate().then(() => {
						this.contractRules = [];
					})
				})
				.catch((err) => {
					if (err.data.errors) {
						err.data.errors.map((e) => {
							this.errorMessage += e.message + ',';
						})
					}
					else {
						this.errorMessage = err.data.message;
					}
				})
				.finally(() => {
					this.loading = false;
				})
		}, 200);
	}

	isDisabledDate = function (currentDate, mode) {
		if (this.model.contractEndDate !== null) {
			if (this.model.contractStartDate > this.model.contractEndDate) {
				this.model.contractEndDate = this.model.contractStartDate
			}
			else if (this.model.contractStartDate == null) {
				this.model.contractEndDate = null
			}
		}
		this.startMinDate = {
			minDate: this.model.contractStartDate
		}
		this.contractDatesChanged();
	}

	selectBillingIncrement(obj) {
		this.model.selectedBillingDuration = obj.value;
	}

	// billingContractRulesModal(data) {
	// 	this.Modal.billingContractRulesModal(data, false, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
	// 		contractRulesOptions.forEach((rules) => {
	// 			this.contractRules.push(rules);
	// 		})
	// 		modal.close();
	// 	}, ({ modal }) => {
	// 		if (modal) modal.close();
	// 	})
	// }

	// editBillingContract(data, index) {
	// 	this.Modal.billingContractRulesModal(data, false, this.model.contractRules = this.generateContractRules(), ({ contractRulesOptions, modal }) => {
	// 		this.contractRules.splice(index, 1);
	// 		contractRulesOptions.forEach((rules) => {
	// 			this.contractRules.splice(index, 0, rules);
	// 		})
	// 		modal.close();
	// 	}, ({ modal }) => {
	// 		if (modal) modal.close();
	// 	})
	// }

	getTime(time, billingType = null) {
		if (!time) {
			return time;
		}

		time = moment(time).format('HH:mm:ss');

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(time[2]);
		// d.setMilliseconds(0);
		const timeFormat = billingType == 'service_ticket_overage_time_charge' ? 'HH:mm:ss' : '00:mm:ss';
		return moment(d).format(timeFormat);
	}

	// generateContractRules() {
	// 	if (!this.contractRules.length) return [];
	// 	const rules = [];

	// 	this.contractRules.forEach((obj) => {
	// 		rules.push({
	// 			billingEvent: obj.billingEvent.key,
	// 			locationType: obj.locationType.value,
	// 			orderType: obj.orderType.value,
	// 			billingType: obj.billingTypeObj.billingType.value,
	// 			minQty: obj.billingTypeObj.min || null,
	// 			maxQty: obj.billingTypeObj.max || null,
	// 			minAmount: obj.billingTypeObj.minAmount || null,
	// 			maxAmount: obj.billingTypeObj.maxAmount || null,
	// 			beginTime: obj.billingTypeObj.beginTime ? moment(obj.billingTypeObj.beginTime).format('00:mm:ss') : null,
	// 			endTime: obj.billingTypeObj.endTime ? moment(obj.billingTypeObj.endTime).format('00:mm:ss') : null,
	// 			billingRate: obj.billingRateObj.rate,
	// 			currencyId: obj.billingRateObj.currency
	// 		})
	// 	})
	// 	return rules;
	// }

	addBillingRules(event) {
		this.billingRulesOptions.push({
			name: null,
			description: null,
			generalLedgerCode: null,
			status: true,
			isValidBillingRules: false,
			billingEventObj: {
				billingEvent: null,
				billingEventOptions: null,
				preBillingEventOptions: _.cloneDeep(this.preBillingEventOptions),
				postBillingEventOptions: _.cloneDeep(this.postBillingEventOptions)
			},
			locationTypeObj: {
				locationType: null,
				locationTypeOptions: []
			},
			serviceTypeObj: {
				serviceType: null,
				serviceTypeOptions: []
			},
			scheduleTypeObj: {
				scheduleType: null,
				scheduleTypeOptions: this.scheduleTypeOptions
			},
			orderTypeObj: {
				orderType: null,
				orderTypeOptions: []
			},
			billingTypeObj: {
				billingType: null,
				billingTypeOptions: this.billingTypeOptions
			},
			dollarRate: null,
			percentageRate: null,
			dollarRateAbove: null,
			percentageRateAbove: null,
			dollarRateBelow: null,
			percentageRateBelow: null,
			itemThreshold: null,
			valueThreshold: null,
			timeThreshold: null,
			itemIncrement: null,
			valueIncrement: null,
			timeIncrement: null,
			isEdit: true,
			applyWrapFee: false,
			wrapFee: null,
			billingTime: 'POST',
			locationDistanceId: null,
			rateFirstHour: null,
			rateFifteenMinutes: null,
			serviceTimeTypeObj: {
				serviceTimeType: []
			},
			locationList: [],
			customerList: [],
			billToCustomerId: null,
			contractRulesLocations: [],
			billableEventId: null,
			billingCategoryId: null,
			billingCategoryObj: {
				billingCategory: null,
				billingCategoryOptions: _.cloneDeep(this.billingCategoryOptions)
			},
			overageRate: null,
			locationOptions: [],
			startDate: this.model.contractStartDate ? this.model.contractStartDate : new Date(),
			endDate: null
		});
		this.getContractLocationList('',null,1, this.billingRulesOptions.length-1)

		event.preventDefault();
	}

	validateBillingRuleFormControl() {
		var disableButton = this.billingRulesOptions.map((data) => {
			this.isValidFormControl = true;
			this.isValidFormControl = this.isValidFormControl && data.isValidBillingRules;
			return this.isValidFormControl;
		})
		if (disableButton.indexOf(false) >= 0 && this.billingRulesOptions.length > 0) return false;
		else return true;
	}

	removeBillingRules(index) {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message') + '?',
			callback: (({
				modal,
				$scope
			}) => {
				this.billingRulesOptions.splice(index, 1);
				this.billingRulesOptions.forEach((cr, index) => {
					this.disableOtherOptions = {};
					setTimeout(()=>{
						if (cr.billingEventObj.billingEvent && this.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
							this.disableOtherOptions[index] = {
								disabled: true
							}
							this.requiredStartDate = true;
						}
						else {
							this.disableOtherOptions[index] = {
								disabled: false
							}	
							this.requiredStartDate = false;	
						}
						this.isAllowScheduleType(cr,index);
					},100)
				})
				modal.close();
				// if(this.billingRulesOptions.length == 0 ) return this.requiredStartDate = false;
				this.isStartDateIsRequired()
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	locationTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant',
			'coin-pickup', 'deposit-count', 'stop-completed'].indexOf(selectedBillingEvent) > -1) {
			obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['other'];
		}
		else if (['coin-delivery'].indexOf(selectedBillingEvent) > -1) {
			obj.locationTypeObj.locationTypeOptions = [...this.locationTypeOptions['other'], ...this.locationTypeOptions['ATM']];
		}
		else if (selectedBillingEvent == 'coin-conversion') {
			const option = { label: 'Any', value: 'any' };
			obj.locationTypeObj.locationTypeOptions = [option];
			obj.locationTypeObj.locationType = option;
		}
		else {
			obj.locationTypeObj.locationTypeOptions = this.locationTypeOptions['ATM'];
		}
	};

	serviceTypeOptionChoice(obj, index) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = [this.serviceTypeOptions['other'][0], ...this.serviceTypeOptions['regular'], ...this.serviceTypeOptions['flm'], ...this.serviceTypeOptions['slm']];
			this.isDisableServiceTypeOptions = false;
		}
		else if (['stop-completed', 'atm-cash-delivery', 'coin-pickup', 'coin-delivery', 'shipment-delivery-cant', 'shipment-pickup',
			      'shipment-delivered', 'atm-cash-pickup', 'atm-deposit-pickup'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['other'];
			this.isDisableServiceTypeOptions = false;
		}
		else if (['atm-load-service', 'atm-load-cant'].indexOf(selectedBillingEvent) > -1) {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['atmLoad'];
			this.isDisableServiceTypeOptions = false;
		}
		else {
			obj.serviceTypeObj.serviceTypeOptions = this.serviceTypeOptions['none'];
			obj.serviceTypeObj.serviceType = this.serviceTypeOptions['none'][0];
			if (['deposit-count', 'atm-order-pack', 'pickup-deposit', 'atm-residual-deposit',
				 'delivery-order-pack', 'atm-residual-count', 'atm-deposit-count'].indexOf(selectedBillingEvent) > -1) {
				this.isDisableServiceTypeOptions = true;
			}
		}
	};

	orderTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (['shipment-delivered', 'shipment-pickup', 'delivery-order-pack', 'pickup-deposit', 'shipment-delivery-cant', 'deposit-count'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = [...this.orderTypeOptions['cash_coin'], ...this.orderTypeOptions['cash_only'], ...this.orderTypeOptions['coin_only']];
		}
		else if (['atm-residual-count', 'atm-load-service', 'atm-order-pack', 'atm-residual-deposit', 'atm-deposit-pickup', 'atm-deposit-count', 'atm-load-cant', 'atm-cash-delivery', 'atm-cash-pickup']
			.indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['ATM'];
		}
		else if (['service-ticket-completed', 'service-ticket-incomplete', 'service-ticket-cancelled', 'part-charge'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['services'];
		}
		else if (['coin-pickup', 'coin-delivery'].indexOf(selectedBillingEvent) > -1) {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['coin_only'];
		}
		else if (['stop-completed', 'coin-conversion'].indexOf(selectedBillingEvent) > -1) {
			const option = { label: 'Any', value: 'none' };
			obj.orderTypeObj.orderTypeOptions = [option];
			obj.orderTypeObj.orderType = option;
		}
		else {
			obj.orderTypeObj.orderTypeOptions = this.orderTypeOptions['other'];
		}
	};

	validateBillingType(obj, index) {
		obj.dollarRate = null;
		obj.percentageRate = null;
		obj.dollarRateAbove = null;
		obj.percentageRateAbove = null;
		obj.dollarRateBelow = null;
		obj.percentageRateBelow = null;
		obj.itemThreshold = null;
		obj.valueThreshold = null;
		obj.timeThreshold = null;
		obj.itemIncrement = null;
		obj.valueIncrement = null;
		obj.timeIncrement = null;
		obj.applyWrapFee = false;
		obj.wrapFee = null;
		obj.billingTime = obj.billingEventObj.billingEvent && this.staticBillingEvents.includes(obj.billingEventObj.billingEvent.value) && obj.billingTypeObj.billingType.value === 'fixed' && obj.billingEventObj.billingEvent.value === 'pre-bill' ? obj.billingTime = 'PRE' : 'POST';
		obj.locationDistanceId = null;
		obj.rateFirstHour = null;
		obj.rateFifteenMinutes = null;
		obj.overageRate = null;
		// obj.serviceTimeTypeObj = {};
			if (obj.billingTypeObj.billingType.value !== 'drive_distance') {
				if(this.model.useCustomerOnBillingRules === true) this.getContractLocationList('',null,1,index);
			}
	}

	resetLocationAndServiceType(obj) {
		obj.serviceTypeObj.serviceTypeOptions = [];
		obj.locationTypeObj.locationTypeOptions = [];
	}

	generateBillingRules(type) {
		if (!this.billingRulesOptions.length) return [];
		this.contractRules = [];

		this.billingRulesOptions.forEach((obj) => {
			this.contractRules.push({
				name: obj.name,
				description: obj.description,
				generalLedgerCode: obj.generalLedgerCode,
				status: obj.status,
				billingEvent: obj.billingEventObj.billingEvent[type],
				billingEventLabel: obj.billingEventObj.billingEvent.label,
				locationType: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType[type] : 'NONE',
				locationTypeLabel: obj.locationTypeObj.locationType ? obj.locationTypeObj.locationType.label : 'NONE',
				serviceType: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType[type] : 'NONE',
				serviceTypeLabel: obj.serviceTypeObj.serviceType ? obj.serviceTypeObj.serviceType.label : 'NONE',
				scheduleType: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType[type] : 'NONE',
				scheduleTypeLabel: obj.scheduleTypeObj.scheduleType ? obj.scheduleTypeObj.scheduleType.label : 'NONE',
				orderType: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType[type] : 'NONE',
				orderTypeLabel: obj.orderTypeObj.orderType ? obj.orderTypeObj.orderType.label : 'NONE',
				billingType: obj.billingTypeObj.billingType[type],
				billingTypeLabel: obj.billingTypeObj.billingType.label,
				dollarRate: obj.dollarRate >= 0 ? obj.dollarRate : null,
				percentageRate: obj.percentageRate >= 0 ? obj.percentageRate : null,
				dollarRateAbove: obj.dollarRateAbove >= 0 ? obj.dollarRateAbove : null,
				percentageRateAbove: obj.percentageRateAbove >= 0 ? obj.percentageRateAbove : null,
				dollarRateBelow: obj.dollarRateBelow >= 0 ? obj.dollarRateBelow : null,
				percentageRateBelow: obj.percentageRateBelow >= 0 ? obj.percentageRateBelow : null,
				itemThreshold: obj.itemThreshold >= 0 ? obj.itemThreshold : null,
				itemIncrement: obj.itemIncrement >= 0 ? obj.itemIncrement : null,
				valueThreshold: obj.valueThreshold >= 0 ? obj.valueThreshold : null,
				valueIncrement: obj.valueIncrement >= 0 ? obj.valueIncrement : null,
				timeThreshold: obj.timeThreshold ? this.getTime(obj.timeThreshold, obj.billingTypeObj.billingType[type]) : null,
				timeIncrement: obj.timeIncrement ? this.getTime(obj.timeIncrement) : null,
				currencyId: 'USD',
				applyWrapFee: obj.applyWrapFee,
				wrapFee: obj.wrapFee,
				billingTime: obj.billingTypeObj.billingType[type] === 'fixed' ? obj.billingTime : null,
				locationDistanceId: obj.locationDistanceId,
				rateFirstHour: obj.rateFirstHour,
				rateFifteenMinutes: obj.rateFifteenMinutes,
				serviceTimeType: obj.serviceTimeTypeObj.serviceTimeType.map(d => d.value).toString(),
				billToCustomerId: obj.billToCustomerId ? obj.billToCustomerId.Value : null,
				contractRulesLocations: obj.contractRulesLocations,
				preBillingEvents: obj.billingEventObj.preBillingEvents,
				postBillingEvents: obj.billingEventObj.postBillingEvents,
				sequence: this.contractRules.length + 1,
				billableEventId: obj.billingEventObj && obj.billingEventObj.billingEvent ? obj.billingEventObj.billingEvent.id : null,
				billingCategoryId: obj.billingCategoryObj && obj.billingCategoryObj.billingCategory ? obj.billingCategoryObj.billingCategory.billingCategoryId : null,
				overageRate: obj.overageRate,
				startDate: obj.startDate ?  moment(obj.startDate).format('YYYY-MM-DD') : null,
				endDate: obj.endDate ? moment(obj.endDate).format('YYYY-MM-DD') : null

			})
		})
	}

	setEditFlag(obj) {
		obj.isEdit = false;
	}

	saveBillingRules(obj, event) {
		event.preventDefault();
		obj.isValidBillingRules = true;
		this.showAllFlag = false;
		this.isStartDateIsRequired();
	}

	percentageMask(input, decimals) {
		return this.$filter('number')(input, decimals) + '%';
	}

	editBillingRules(obj) {
		obj.isEdit = true;
		obj.isValidBillingRules = false;
	}

	isInvalidForm() {
		return !this.model.contractName || !this.model.selectedBillingDuration || (!this.model.contractStartDate && this.requiredStartDate) || !this.model.contractStartDate;
	}

	ifUndefined(v, mixed) {
		return (typeof v === 'undefined' || v === null) ? mixed : v;
	};

	getBillableEvents() {
		this.preBillingEventOptions = [];
		this.postBillingEventOptions = [];
		this.billingCategoryOptions = [];

		this.BillableEventsService.all(null, 0, 100)
			.then((events) => {
				events.results.forEach(d => {
					this.preBillingEventOptions.push({
						id: d.id,
						label: this.$translate.instant(`entry_type.${d.type}`),
						value: d.type
					})
				})
				this.preBillingEventOptions = _.sortBy(this.preBillingEventOptions, ['label', 'ASC']);
				this.postBillingEventOptions = _.sortBy(this.preBillingEventOptions, ['label', 'ASC']);

				const billableEvents = events.results.reduce((acc, result) => {
					const categoryName = result.billingCategory.name;
					acc[categoryName] = acc[categoryName] || {
						billingEvents: [],
						billingCategoryId: result.billingCategoryId,
					};
					acc[categoryName].billingEvents.push({
						id: result.id,
						label: this.$translate.instant(`entry_type.${result.type}`),
						value: result.type
					});
					return acc;
				}, {});


				this.billingCategoryOptions = Object.keys(billableEvents).map(key => {
					return {
						label: key,
						billingCategoryId: billableEvents[key].billingCategoryId,
						billingEvents: billableEvents[key].billingEvents
					}
				})

			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.loading = false;
			})
	}

	getBillingEventsByCategory(contractRuleObj, index) {
		this.resetLocationAndServiceType(contractRuleObj);
		contractRuleObj.billingEventObj.billingEventOptions = contractRuleObj.billingCategoryObj.billingCategory.billingEvents
	}

	locationDistanceList() {
		this.LocationDistanceService.all(null, 0, 100)
			.then((data) => {
				this.model.locationDistanceOptions = data.results;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	updateLocationDistance(contractRules, locationDistanceId, index) {
		contractRules.locationDistance = _.find(this.model.locationDistanceOptions, { 'id': locationDistanceId });
		this.showAllFlag = false;
		if (this.model.useCustomerOnBillingRules === true) this.getContractLocationList('', contractRules.locationDistanceId, 1, index);
		setTimeout(() => {
			const applicableLocations = this.model.locationList

			const filteredLocations =  applicableLocations
					.filter((ele) => this.billingRulesOptions[index].contractRulesLocations.includes(ele.value))
					.map((ele) => ele.value);
		
			
			this.billingRulesOptions[index].contractRulesLocations = filteredLocations.length > 0 ? filteredLocations : [];
			this.$scope.$apply()
		}, 500);
	}

	preOrPostBillCfg(obj, index) {
		if (!obj.billingEventObj.billingEvent) return;
		
		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (this.staticBillingEvents.includes(selectedBillingEvent)) {
			this.disableOtherOptions[index] = {
				disabled: true
			};
			obj.locationTypeObj.locationType = null;
			obj.serviceTypeObj.serviceType = null;
			obj.scheduleTypeObj.scheduleType = null;
			obj.orderTypeObj.orderType = null;
			obj.billingTypeObj.billingType = {
				label: 'Fixed',
				value: 'fixed'
			}
			obj.billingTime = selectedBillingEvent === 'pre-bill' ? 'PRE' : 'POST';
			obj.dollarRate = null;
			obj.percentageRate = null;
			obj.dollarRateAbove = null;
			obj.percentageRateAbove = null;
			obj.dollarRateBelow = null;
			obj.percentageRateBelow = null;
			obj.itemThreshold = null;
			obj.valueThreshold = null;
			obj.timeThreshold = null;
			obj.itemIncrement = null;
			obj.valueIncrement = null;
			obj.timeIncrement = null;
			obj.isEdit = true;
			obj.applyWrapFee = false;
			obj.wrapFee = null;
			obj.locationDistanceId = null;
			obj.rateFirstHour = null;
			obj.rateFifteenMinutes = null;
			obj.overageRate = null;
			this.model.selectedBillingDuration = 'MONTHLY';
			this.model.disableBillingIncrement = true;
			this.requiredStartDate = true;
		}
		else {
			this.model.disableBillingIncrement = false;
			this.disableOtherOptions[index] = {
				disabled: false
			};
			obj.billingTime = 'POST';
			this.requiredStartDate = false;
			obj.billingTypeObj.billingType = null;
			setTimeout(() => {
				obj.billingEventObj.preBillingEvents = [];
				obj.billingEventObj.preBillingEventOptions.forEach((pbe) => {
					pbe.ticked = false;
				})

				obj.billingEventObj.postBillingEvents = [];
				obj.billingEventObj.postBillingEventOptions.forEach((pbe) => {
					pbe.ticked = false;
				})
			})
		}

		this.isStartDateIsRequired()
	}

	isAllowScheduleType(obj, index) {
		if (!obj.billingEventObj.billingEvent) return;

		let selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (this.allowScheduleTypeBillingEvents.includes(selectedBillingEvent)) {
			this.disableScheduleTypeOptions[index] = {
				disabled: true
			};
			obj.scheduleTypeObj.scheduleType = null;
		}
		else {
			this.disableScheduleTypeOptions[index] = {
				disabled: false
			};
		}
	}

	isStartDateIsRequired() {
		if (!this.billingRulesOptions.length) this.requiredStartDate = false;

		this.billingRulesOptions.forEach((br) => {
			if (br.billingEventObj.billingEvent && br.billingEventObj.billingEvent.value == "pre-bill") this.requiredStartDate = true;
		})
	}

	bulkImportLocationModal(data, index) {
		data.contractId = this.model.contractId;
		data.useCustomerOnBillingRules = this.model.useCustomerOnBillingRules;
		data.showAll = this.showAllFlag
		this.Modal.bulkImportLocation(data, ({ locationList, modal }) => {
			if (locationList && locationList.length > 0) {
				locationList.forEach(l1 => {
					data.contractRulesLocations.push(l1)
				})
			}
			modal.close();
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	billingTypeOptionChoice(obj) {
		if (!obj.billingEventObj.billingEvent) return;

		const selectedBillingEvent = obj.billingEventObj.billingEvent.value;

		if (!selectedBillingEvent) return;

		if (this.staticBillingEvents.includes(selectedBillingEvent)) {
			let fixedOption = this.billingTypeOptions.find(bt => bt.label === 'Fixed');
			obj.billingTypeObj.billingTypeOptions = [fixedOption];
		} 
		else if(selectedBillingEvent === 'stop-completed') {
			const options = this.billingTypeOptions.filter(bt => ['fixed', 'per_item'].includes(bt.value));
			obj.billingTypeObj.billingTypeOptions = options;
		}
		else if (selectedBillingEvent === 'coin-conversion') {
			let perItemOption = this.billingTypeOptions.find(bt => bt.value === 'per_item');
			obj.billingTypeObj.billingTypeOptions = [perItemOption];
			obj.billingTypeObj.billingType = { label: "Per Item", value: "per_item" };
		}
		else if (selectedBillingEvent === 'atm-residual-count') {
			const options = this.billingTypeOptions.filter(bt => ['fixed', 'per_item', 'percentage_fee'].includes(bt.value));
			obj.billingTypeObj.billingTypeOptions = options;
		}
		else {
			obj.billingTypeObj.billingTypeOptions = this.billingTypeOptions;
		}
	};

	resetBillToCustomers() {
		this.billingRulesOptions.forEach((obj) => {
			obj.billToCustomerId = null;
			obj.contractRulesLocations = [];
			if(this.model.useCustomerOnBillingRules=== true) this.getContractLocationList('', obj.locationDistanceId, 1);
		})
	}

	getCustomerList(searchKey, offset) {
		this.model.customerObj.loading = true;
		this.Service.getCustomerList(searchKey, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.customerObj.totalRecords = data.totalRecords;
					this.model.customerObj.results = this.dataMapping(data.results, 'key', 'value');
				} else {
					const customers = this.dataMapping(data.results, 'key', 'value');
					this.model.customerObj.results = this.model.customerObj.results.concat(customers);
				}

				this.cloneCustomerListLObj = {
					customerList: this.model.customerObj.results,
					totalCustomers: this.model.customerObj.totalRecords
				}
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.model.customerObj.loading = false;
			})
	}

	dataMapping(data, key, value) {
		return data.map((obj) => {
			return {
				Key: obj[key],
				Value: obj[value]
			}
		});
	}

	getContractLocationList(searchKey = '', locationDistanceId, page = 1, index, selectAllFlag = false) {
		setTimeout(() => {
			let queryDataLimit = selectAllFlag ? (this.model.totalLocations || this.contractLocationListObj.pagination.pageLimit) : this.contractLocationListObj.pagination.pageLimit;
			this.Service.contractLocationList(searchKey, locationDistanceId, (page - 1) * this.contractLocationListObj.pagination.pageLimit, queryDataLimit)
				.then((res) => {
					if (res.results) {
						if (page == 1) {
							this.model.locationList = [];
							if(index != null && this.billingRulesOptions[index]){
								this.billingRulesOptions[index].locationOptions = [];
							}
						}
						if(this.billingRulesOptions[index] && this.billingRulesOptions[index].locationOptions){
							this.billingRulesOptions[index].locationOptions = _.uniqBy(this.billingRulesOptions[index].locationOptions.concat(res.results), 'value');
						}
						this.model.locationList = _.uniqBy(this.model.locationList.concat(res.results), 'value');
						this.model.totalLocations = res.totalRecords;
						this.cloneContractLocationListLObj = {
							locationList: this.model.locationList,
							totalLocations: this.model.totalLocations
						}
						if(index !== null && this.billingRulesOptions[index]){
							this.billingRulesOptions[index].contractLocationsDistance = new Array(res.totalRecords).fill('');
						}
					}
				})
				.catch((err) => {
					console.log(err);
				})
		})
	}

	filterChange(contractRules) {
		// console.log(contractRules.contractRulesLocations)
	}

	clear() {
		this.model.contractEndDate = null;
	}

	updateContractRuleStatus(index, isActive) {
		setTimeout(() => {
			const id = isActive ? `active-btn-${index}` : `inactive-btn-${index}`;
			return document.getElementById(id).blur();	
		});
	}

	validateRecordOnSequenceChange() {
		setTimeout(() => {
			this.disableOtherOptions = {};
			this.billingRulesOptions.forEach((cr, index) => {
				if (cr.billingEventObj.billingEvent && this.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
					this.disableOtherOptions[index] = {
						disabled: true
					}
					this.requiredStartDate = true;
				}
				else {
					this.disableOtherOptions[index] = {
						disabled: false
					}
					this.requiredStartDate = false;
				}
				this.isAllowScheduleType(cr, index);
			}, 100)
		})
	};

	duplicateBillingRule(obj) {
		const records = _.cloneDeep(obj);
		this.getContractLocationList('', obj.locationDistanceId ? obj.locationDistanceId : null , 1, this.billingRulesOptions.length)
		this.billingRulesOptions.push(records);
		this.validatePreOrPostBillingOptions();
	}

	validatePreOrPostBillingOptions() {
		setTimeout(() => {
			this.disableOtherOptions = {};
			this.billingRulesOptions.forEach((cr, index) => {
				if (cr.billingEventObj.billingEvent && this.staticBillingEvents.includes(cr.billingEventObj.billingEvent.value)) {
					this.disableOtherOptions[index] = {
						disabled: true
					}
					this.requiredStartDate = true;
				}
				else {
					this.disableOtherOptions[index] = {
						disabled: false
					}
					this.requiredStartDate = false;
				}
				this.isAllowScheduleType(cr, index);
			})
			this.$scope.$apply()

		}, 100)
	}

	onDrop(event, index, item, external, type) {
		const updatedOptions = angular.copy(this.billingRulesOptions);
		const itemIndex = updatedOptions.findIndex((opt) => opt.sequence === item.sequence);

		if (itemIndex === -1) return false;

		const removedItem = updatedOptions.splice(itemIndex, 1)[0];
		const newIndex = itemIndex < index ? index - 1 : index;
		removedItem.sequence = newIndex;
		updatedOptions.splice(newIndex, 0, removedItem);

		updatedOptions.forEach((opt, idx) => {
			opt.sequence = idx;
		});

		this.billingRulesOptions = updatedOptions;
		this.validateRecordOnSequenceChange();

		return true;
	}

	getContractTypeList(searchKey, offset) {
		setTimeout(()=>{

			searchKey = searchKey || '';
	
			const obj = {
				queryJSON: {
					rules: [
						{
							group: {
								rules: [
									{
										field: "id",
										condition: "like",
										data: "%" + searchKey + "%"
									},
									{
										field: "type",
										condition: "like",
										data: "%" + searchKey + "%"
									}
								],
								operator: "OR"
							}
						}
					],
					operator: "AND"
				}
			}
	
			this.model.contractTypeObj.loading = true;
			return this.ContractTypeService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
					if (offset === 0 || offset == undefined) {
						this.model.contractTypeObj.totalRecords = data.total;
						this.model.contractTypeObj.results = this.mapContractData(data.results);
					} else {
						const contractType = this.mapContractData(data.results);
						this.model.contractTypeObj.results = this.model.contractTypeObj.results.concat(contractType);
					}
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.model.contractTypeObj.loading = false;
				})
		})
	}

	mapContractData(mapArray) {
		return mapArray.map((obj) => {
			return {
				Key: obj.type,
				Value: obj.id
			}
		});
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	ngPercentage() {
		if (this.model.bailmentInterest && !this.model.bailmentInterest.endsWith('%')) {
			return this.model.bailmentInterest = this.model.bailmentInterest + '%';
		}
	}

	removePercentageSign() {
		if (this.model.bailmentInterest && this.model.bailmentInterest.endsWith('%')) {
			return this.model.bailmentInterest = this.model.bailmentInterest.replace('%', '');
		}
	}
	contractDatesChanged() {
		const { contractStartDate, contractEndDate } = this.model;
		
		this.ruleStartDateOptions = {
			minDate: moment(contractStartDate),
			...(contractEndDate && { maxDate: moment(contractEndDate) }),
		};
	
		this.showBillingWarning = this.billingRulesOptions.some((rule, index) => {
			const ruleStartDate = moment(rule.startDate);
			const ruleEndDate = rule.endDate ? moment(rule.endDate) : null;
		
			const contractStart = moment(contractStartDate);
			const contractEnd = contractEndDate ? moment(contractEndDate) : null;

			if(!contractStartDate)  return false;
		
			const isInvalidStart = ruleStartDate.isValid() && !(
				ruleStartDate.isSameOrAfter(contractStart, "day") && 
				(contractEnd ? ruleStartDate.isSameOrBefore(contractEnd, "day") : true)
			);
	
			const isInvalidEnd = ruleEndDate && ruleEndDate.isValid() && !(
				ruleEndDate.isSameOrAfter(contractStart, "day") && 
				(contractEnd ? ruleEndDate.isSameOrBefore(contractEnd, "day") : true)
			);
		
			const isRuleInvalid = isInvalidStart || isInvalidEnd;
			return isRuleInvalid;
		});
	}
}

export default ContractCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/create/contract.create.controller.js